import { Footer, Header } from '../../ui-elements';
import { useScrollToTopOnLoad } from '../../util';
import { getAllSections } from './util';

export function TermsAndConditions() {
  const allSections = getAllSections();
  useScrollToTopOnLoad();
  return (
    <>
      <Header />
      <div className="px-6 py-4 md:px-20 md:py-14">
        <h1 className="mb-8 text-center text-4xl text-[#1E0E62]">
          Terms and Conditions
        </h1>
        <div className="my-4 text-2xl font-bold">Overview</div>
        <p>
          This website is operated by{' '}
          <b className="text-black">Lexgen Technologies Private Limited.</b>
          Throughout the site, the terms “we”, “us” and “our” refer to{' '}
          <b className="text-black">
            Lexgen Technologies Private Limited. Lexgen Technologies Private
            Limited{' '}
          </b>
          offers this website, including all information, tools and services
          available from this site to you, the user, conditioned upon your
          acceptance of all terms, conditions, policies and notices stated here.
          <br />
          <br />
          By visiting our site and/ or purchasing something from us, you engage
          in our “Service” and agree to be bound by the following terms and
          conditions (“Terms of Service”, “Terms”), including those additional
          terms and conditions and policies referenced herein and/or available
          by hyperlink. These Terms of Service apply to all users of the site,
          including without limitation users who are browsers, vendors,
          customers, merchants, and/ or contributors of content.
          <br />
          <br />
          Please read these Terms of Service carefully before accessing or using
          our website. By accessing or using any part of the site, you agree to
          be bound by these Terms of Service. If you do not agree to all the
          terms and conditions of this agreement, then you may not access the
          website or use any services. If these Terms of Service are considered
          an offer, acceptance is expressly limited to these Terms of Service.
          <br />
          <br />
          Any new features or tools which are added to the current store shall
          also be subject to the Terms of Service. You can review the most
          current version of the Terms of Service at any time on this page. We
          reserve the right to update, change or replace any part of these Terms
          of Service by posting updates and/or changes to our website. It is
          your responsibility to check this page periodically for changes. Your
          continued use of or access to the website following the posting of any
          changes constitutes acceptance of those changes.
        </p>
        <div>
          {allSections.map((section, i) => (
            <div key={section.id} className="my-8">
              <div className="my-4 text-2xl font-bold">
                {i + 1}. {section.title}
              </div>
              <div>{section.content}</div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
